import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { advancedRoadmapsPlanPageInitialChecksResource } from '@atlassian/jira-router-resources-advanced-roadmaps-plan/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { planSetupPageRoute } from '@atlassian/jira-router-routes-advanced-roadmaps-routes/src/planSetupPageRoute.tsx';
import SetupPage, { LazyAdvancedRoadmapsSetup } from './ui/setup/index.tsx';

export const planSetupPageRouteEntry = createEntry(planSetupPageRoute, () => ({
	group: 'software',
	component: SetupPage,
	layout: globalLayout,
	resources: [...getNavigationResources(), advancedRoadmapsPlanPageInitialChecksResource],
	forPaint: [LazyAtlassianNavigation, LazyAdvancedRoadmapsSetup],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-advanced-roadmaps-entries/src/planSetupPageRouteEntry.tsx',
			whichExportToUse: 'planSetupPageRouteEntry',
		},

		enabled: true,
	},
}));
